import React from "react";

const NotFoundText = () => {
  return (
    <div className="empty-products-container">
      <img src="/assets/img/no-product-found.jpg" alt="no product found" />
      <h3>No Product Matches The Search!</h3>
    </div>
  );
};

export default NotFoundText;
